<script>

  import FlexibleContent from '@/components/FlexibleContent'
  import { HeadMeta } from '@/utils/head-meta'

  export default {
    components: {
      FlexibleContent
    },
    async asyncData ({ app, params, error }) {
      try {
        const { items } = await app.$contentful.getEntries({
          content_type: 'page',
          'fields.slug': 'privacy',
          include: 2
        })
        if (!items.length) error({ statusCode: 404, message: 'This page could not be found' })
        return {
          page: items[0]
        }
      } catch (e) {
        error(e)
      }
    },
    head () {
      return HeadMeta(this.page.fields)
    },
    methods: {
      handleCookieChange () {
        this.$store.commit('gdpr/SHOW_NOTICE', true)
      }
    }
  }
</script>

<template>
  <article class="view view-page">
    <header class="view-header">
      <div class="container px-4 md:px-8">
        <div class="w-full md:w-10/12 xl:w-6/12 mx-auto md:text-center">
          <animated-title>
            <h1 class="animate text-3xl md:text-5xl pb-4">
              {{ page.fields.title }}
            </h1>
          </animated-title>
          <rich-text-content
            :content="page.fields.introduction"
            class="text-lg mb-10"
          />
        </div>
      </div>
    </header>
    <div class="container px-4 md:px-8">
      <div class="w-full md:w-8/12 lg:w-6/12 mx-auto">
        <e-button
          class="mb-6"
          @click="handleCookieChange"
        >
          Cookie-instellingen wijzigen
        </e-button>
      </div>
    </div>
    <flexible-content :content="page.fields.content" />
  </article>
</template>
